export default "__VITE_ASSET__$E$aymGQ__"